import React from 'react'
import '../style/mangemnet.css'
import work1 from '../images/work1.jpg'
import work2 from '../images/work2.jpg'

const Mangemnet = () => {
    return (
        <>
            <div className='container' style={{ marginTop: '30px' }}>
                <div className='container'>
                    <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                        <h3 style={{ padding: '7px', color: 'rgb(13 92 126)' }}>OUR ASSISTANCE</h3>
                        <img src="https://icons.veryicon.com/png/o/business/gmh-icon-library/peer-help.png" width={'50px'} height={'50px'} style={{ marginRight: '15px', marginTop: '10px' }} alt="Businesses" />
                    </div>
                </div>
                <div className='row' style={{ marginTop: '30px' }} id='rM'>
                    <div className='col'>
                        <img className='w-100 h-100' src={work1} alt="business" id='iMM' />
                    </div>
                    <div className='col' id='colDD'>
                        <h3 style={{ color: 'rgb(13 92 126)', marginTop:"60px" }}>1. To Businesses</h3>
                        <p style={{ fontSize: '15px' }}>Boost your business for growth and success. Partner with us for sustainable, profitable expansion through :</p>
                        <ul style={{ fontSize: '15px' }}>
                            <li>Growth Planning</li>
                            <li>Scalability Check</li>
                            <li>Process Re-engineering</li>
                            <li>Strategic Partnerships & Mentoring</li>
                        </ul>
                        <div className='btnTalk' >
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '18px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ flexDirection: 'row-reverse' }} id='rMM'>
                    <div className='col' style={{marginRight:"48px"}} >
                        <img className='w-100 h-100' src={work2} alt="people" />
                    </div>
                    <div className='col' id='rmarg'>
                        <h3 style={{ color: 'rgb(13 92 126)', marginTop:"60px" }}>2. To People</h3>
                        <p style={{ fontSize: '15px' }}>Unleash your team's potential and achieve results with our:</p>
                        <ul style={{ fontSize: '15px' }}>
                            <li>Vision & Performance Systems</li>
                            <li>Leadership Assessments</li>
                            <li>Executive & Life Coaching</li>
                            <li>Customized Workshops</li>
                            <li>Game-Based Learning</li>
                        </ul>
                        <div className='btnTalk' >
                            <a href="/ContactUs" >
                                <button type="button" id='btnHvn' style={{ fontSize: '15px', marginTop: "10px", fontWeight: '500' }} className="btn btn-primary btn-lg">Explore More
                                    <img src="https://www.svgrepo.com/show/170013/right-arrow.svg" style={{ marginLeft: '10px' }} width={'30px'} height={'25x'} alt="arrow" />
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
        
            </div>
        </>
    )
}

export default Mangemnet
